/* eslint-disable no-sequences */
/* eslint-disable babel/no-invalid-this */
/* eslint-disable eqeqeq */
/* eslint-disable no-eq-null */
/* eslint-disable no-void */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-var */

/* Copyright Iterable */
(function() {
    var account;
    var identify;
    var iterableAnalytics;
    var post;
    var push;
    var track;
    var trackPurchase;
    var updateCart;
    (iterableAnalytics = {}),
        (post = function(endpoint, data, callback) {
            var xhr;
            return (
                (xhr = window.XMLHttpRequest
                    ? new XMLHttpRequest()
                    : new ActiveXObject('Microsoft.XMLHTTP')),
                (xhr.onreadystatechange = function() {
                    var status;
                    // eslint-disable-next-line yoda
                    return 4 === xhr.readyState && ((status = xhr.status), callback)
                        ? callback(
                              status,
                              status === 200
                                  ? JSON.parse(xhr.responseText)
                                  : (() => {
                                        try {
                                            return JSON.parse(xhr.responseText);
                                        } catch {
                                            return xhr.responseText;
                                        }
                                    })()
                          )
                        : void 0;
                }),
                xhr.open('POST', iterableAnalytics.baseUrl + endpoint, !0),
                xhr.setRequestHeader('Content-Type', 'application/json'),
                xhr.setRequestHeader('Api-Key', iterableAnalytics.apiKey),
                xhr.send(JSON.stringify(data))
            );
        }),
        (account = function(apiKey, baseUrl) {
            return (
                (iterableAnalytics.apiKey = apiKey),
                (iterableAnalytics.baseUrl = baseUrl || 'https://api.iterable.com')
            );
        }),
        (identify = function(email, data, callback) {
            return (
                (iterableAnalytics.user = {
                    email: email,
                    data: data || {},
                }),
                Object.keys(data).length !== 0
                    ? post(
                          '/api/users/update',
                          {
                              email: email,
                              dataFields: data,
                          },
                          callback
                      )
                    : void 0
            );
        }),
        (track = function(eventName, data, callback) {
            return iterableAnalytics.user != null
                ? post(
                      '/api/events/track',
                      {
                          email: iterableAnalytics.user.email,
                          eventName: eventName,
                          dataFields: data,
                      },
                      callback
                  )
                : void 0;
        }),
        (updateCart = function(items, callback) {
            return iterableAnalytics.user != null
                ? post(
                      '/api/commerce/updateCart',
                      {
                          user: {
                              email: iterableAnalytics.user.email,
                          },
                          items: items || [],
                      },
                      callback
                  )
                : void 0;
        }),
        (trackPurchase = function(total, items, campaignId, callback) {
            var data;
            return iterableAnalytics.user != null
                ? ((data = {
                      user: {
                          email: iterableAnalytics.user.email,
                      },
                      items: items || [],
                      total: total,
                  }),
                  campaignId != null && (data.campaignId = campaignId),
                  post('/api/commerce/trackPurchase', data, callback))
                : void 0;
        }),
        (push = function(cmd) {
            var args;
            var func;
            var funcName;
            return (
                (funcName = cmd[0]),
                (func = iterableAnalytics[funcName]),
                func != null ? ((args = cmd.slice(1)), func.apply(this, args)) : void 0
            );
        }),
        (iterableAnalytics.account = account),
        (iterableAnalytics.identify = identify),
        (iterableAnalytics.track = track),
        (iterableAnalytics.updateCart = updateCart),
        (iterableAnalytics.trackPurchase = trackPurchase),
        (iterableAnalytics.push = push),
        (iterableAnalytics.isIAQ = !0),
        (iterableAnalytics.post = post),
        (window.iterableAnalytics = iterableAnalytics),
        window._iaq != null
            ? window._iaq.isIAQ == null &&
              (window._iaq.map((cmd) => {
                  return iterableAnalytics.push(cmd);
              }),
              (window._iaq = iterableAnalytics))
            : (window._iaq = iterableAnalytics);
}.call(this));
